import { render } from "./template-preview.vue?vue&type=template&id=83b34908"
import script from "./template-preview.vue?vue&type=script&lang=js"
export * from "./template-preview.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_b6f5290c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__